// import React, { useEffect, useState } from "react";
// import Logo_gopaperless from "../../assets/images/logos/paperless/gopaperless-logo-darkblue-2.png";
// import Image1 from "../../assets/images/pictures/1.jpg";
// import Image2 from "../../assets/images/pictures/2.jpg";
// import Image3 from "../../assets/images/pictures/3.jpg";
// import Image4 from "../../assets/images/pictures/4.jpg";
// import Image5 from "../../assets/images/pictures/5.jpg";
// import { ReactComponent as QR } from "../../assets/images/pictures/bing_generated_qrcode.svg";
// import { ReactComponent as IOS } from "../../assets/images/pictures/IOS.svg";
// import { ReactComponent as Android } from "../../assets/images/pictures/Android.svg";
// import { motion, AnimatePresence } from "framer-motion";
// const DownloadContent = () => {
//     const carouselRef = React.useRef(null);
//   const [showUatModal, setShowUatModal] = useState(false);
//   const [showProModal, setShowProModal] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

//   const images = [Image1, Image2, Image3, Image4, Image5];
//   const [currentIndex, setCurrentIndex] = useState(0);

//    // Hàm chuyển slide
//   const nextSlide = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setCurrentIndex((prev) => (prev + 1) % images.length);
//     e.target.blur();
//   };

//   const prevSlide = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
//     e.target.blur();
//   };

//  useEffect(() => {
//     const preventScroll = (e) => {
//       if (carouselRef.current && carouselRef.current.contains(e.target)) {
//         e.preventDefault();
//       }
//     };

//     document.addEventListener("touchmove", preventScroll, { passive: false });
//     return () => document.removeEventListener("touchmove", preventScroll);
//   }, []);
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const modalWidth = isMobile ? "90%" : "40%";
//   const buttonWidth = isMobile ? "150px" : "200px";
//   const buttonHeight = isMobile ? "50px" : "auto";
//   const buttonFontSize = isMobile ? "14px" : "14px";

//   useEffect(() => {
//     const handleEsc = (e) => {
//       if (e.key === "Escape") {
//         setShowUatModal(false);
//         setShowProModal(false);
//       }
//     };
//     if (showUatModal || showProModal) {
//       window.addEventListener("keydown", handleEsc);
//       return () => window.removeEventListener("keydown", handleEsc);
//     }
//   }, [showUatModal, showProModal]);

//   // UAT
//   const uatIosLink =
//     "itms-services://?action=download-manifest&url=https://gopaperless.mobile-id.vn/downloads/uat/ipa/ipad.plist";
//   const uatAndroidLink =
//     "https://gopaperless.mobile-id.vn/downloads/uat/android/gopaperless.apk";

//   // PRODUCTION
//   const proIosLink =
//     "itms-services://?action=download-manifest&url=https://gopaperless.mobile-id.vn/downloads/production/ipa/ipad.plist";
//   const proAndroidLink =
//     "https://gopaperless.mobile-id.vn/downloads/production/android/gopaperless.apk";

//   return (
//     <div
//       id="content"
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         marginTop: "60px",
//         // justifyContent: "center",
//         alignItems: "center",
//         width: "100%",
//         backgroundColor: "white",
//         textAlign: "center",
//         position: "relative",
//         gap: "16px",
//       }}
//     >
//       <a
//         href="https://gopaperless.mobile-id.vn/downloads"
//         target="_blank"
//         rel="noopener noreferrer"
//         style={{ display: "block", marginBottom: "16px" }}
//       >
//         <img
//           src={Logo_gopaperless}
//           alt="GoPaperless Logo"
//           style={{
//             maxWidth: isMobile ? "200px" : "300px",
//             height: "auto",
//             display: "block",
//             cursor: "pointer",
//           }}
//         />
//       </a>

//       <QR style={{ width: "200px", height: "200px" }} />
//       <div
//         style={{
//           display: "flex",
//           flexDirection: isMobile ? "column" : "row",
//           gap: "10px",
//         }}
//       >
//         <button
//           onClick={() => setShowProModal(true)}
//           className="btn btn-primary rounded-pill px-4 py-2"
//           style={{
//             fontSize: buttonFontSize,
//             fontWeight: 500,
//             width: buttonWidth,
//             padding: isMobile ? "14px" : "8px 16px",
//             minHeight: buttonHeight,
//             alignItems: "center",
//             justifyContent: "center",
//             display: "flex",
//           }}
//         >
//           PRODUCTION
//         </button>
//         <button
//           onClick={() => setShowUatModal(true)}
//           className="btn btn-primary rounded-pill px-4 py-2"
//           style={{
//             fontSize: buttonFontSize,
//             fontWeight: 500,
//             width: buttonWidth,
//             padding: isMobile ? "14px" : "8px 16px",
//             minHeight: buttonHeight,
//             alignItems: "center",
//             justifyContent: "center",
//             display: "flex",
//           }}
//         >
//           DEMO
//         </button>
//       </div>
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           gap: "8px",
//           width: "50dvw",
//           justifyContent: "center",
//           alignItems: "center",
//         }}
//       >
//         <span style={{ fontSize: "16px", color: "#555", fontWeight: "bold" }}>
//           SETTING THE ENTERPRISE DEVELOPER TRUST IN IPHONE
//         </span>
//         <span style={{ fontSize: "14px", color: "#555", fontWeight: 500 }}>
//           IT IS NEED TO SET THE ENTERPRISE DEVELOPER TRUST IN IPHONE (IOS 9 AND
//           ABOVE) AFTER INSTALLING THE APP PACKED BY APPLE ENTERPRISE KEY.
//           OTHERWISE, THE APP COULDN'T BE OPEN NORMALLY.
//         </span>
//       </div>

//             <div
//   ref={carouselRef}
//   style={{
//     position: "relative",
//     width: "100%",
//     maxWidth: "500px",
//     height: "auto",                 // hoặc set fixed height nếu ảnh đều (ví dụ 500px)
//     minHeight: "300px",             // tránh collapse khi load
//     overflow: "hidden",
//     borderRadius: "12px",
//     boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
//     marginTop: "16px",
//     marginBottom: "16px",
//     backgroundColor: "#dddddd",
//   }}
// >
//   <AnimatePresence initial={false}>
//     <motion.img
//       key={currentIndex}
//       src={images[currentIndex]}
//       alt={`Slide ${currentIndex + 1}`}
//       initial={{ x: 300, opacity: 0 }}
//       animate={{ x: 0, opacity: 1 }}
//       exit={{ x: -300, opacity: 0 }}
//       transition={{ duration: 0.5, ease: "easeInOut" }}
//       style={{
//         position: "absolute",
//         inset: 0,
//         width: "100%",
//         height: "100%",
//         objectFit: "contain",
//         margin: "0 auto",
//       }}
//     />
//   </AnimatePresence>

//   {/* Nút Prev / Next */}
//   <button
//     type="button"
//     tabIndex={-1}
//     onClick={prevSlide}
//     style={{ /* giữ nguyên */ }}
//   >
//     ←
//   </button>

//   <button
//     type="button"
//     tabIndex={-1}
//     onClick={nextSlide}
//     style={{ /* giữ nguyên */ }}
//   >
//     →
//   </button>

//   {/* Dots - giữ nguyên nhưng dùng button */}
//   <div
//     style={{
//       position: "absolute",
//       bottom: "12px",
//       left: "50%",
//       transform: "translateX(-50%)",
//       display: "flex",
//       gap: "8px",
//       zIndex: 10,
//     }}
//   >
//     {images.map((_, index) => (
//       <button
//         key={index}
//         type="button"
//         onClick={(e) => {
//           e.preventDefault();
//           e.stopPropagation();
//           setCurrentIndex(index);
//           e.target.blur();
//         }}
//         style={{
//           width: "10px",
//           height: "10px",
//           borderRadius: "50%",
//           background: index === currentIndex ? "#00a9da" : "rgba(255,255,255,0.7)",
//           border: "none",
//           cursor: "pointer",
//           padding: 0,
//         }}
//       />
//     ))}
//   </div>
// </div>
//       {/* <footer
//         style={{
//           position: "absolute",
//           bottom: "16px",
//           textAlign: "center",
//           fontSize: "14px",
//           color: "#6c757d",
//           width: "100%",
//           backgroundColor: "transparent",
//           borderTop: "none",
//         }}
//       >
//         <a
//           href="https://gopaperless.vn/uploads/GoPaperless-ChinhSachThuThapVaXuLyDuLieuCaNhan"
//           target="_blank"
//           rel="noopener noreferrer"
//           style={{
//             color: "#2563eb",
//             textDecoration: "none",
//             marginRight: "8px",
//           }}
//         >
//           Terms of use
//         </a>
//         <span style={{ color: "#ccc" }}>|</span>
//         <a
//           href="https://gopaperless.vn/uploads/GoPaperless-ChinhSachBaoMatThongTin"
//           target="_blank"
//           rel="noopener noreferrer"
//           style={{
//             color: "#2563eb",
//             textDecoration: "none",
//             marginLeft: "8px",
//           }}
//         >
//           Privacy policy
//         </a>
//       </footer> */}
//       {/* UAT */}
//       <AnimatePresence>
//         {showUatModal && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             style={{
//               position: "fixed",
//               inset: 0,
//               backgroundColor: "rgba(0,0,0,0.5)",
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               zIndex: 9999,
//             }}
//             onClick={() => setShowUatModal(false)}
//           >
//             <motion.div
//               initial={{ scale: 0.85, opacity: 0 }}
//               animate={{ scale: 1, opacity: 1 }}
//               exit={{ scale: 0.85, opacity: 0 }}
//               transition={{ type: "spring", damping: 30, stiffness: 400 }}
//               onClick={(e) => e.stopPropagation()}
//               style={{
//                 background: "white",
//                 borderRadius: "8px",
//                 width: modalWidth,
//                 maxHeight: "85vh",
//                 boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
//                 overflow: "hidden",
//                 display: "flex",
//                 flexDirection: "column",
//               }}
//             >
//               {/* Header */}
//               <div
//                 style={{
//                   padding: "18px 20px",
//                   backgroundColor: "#fcfcfc",
//                   color: "#00a9da",
//                   fontWeight: "600",
//                   fontSize: "19px",
//                   textAlign: "start",
//                   position: "relative",
//                   borderBottom: "2px solid",
//                   borderColor: "#e5e5e5",
//                 }}
//               >
//                 DEMO
//                 <button
//                   onClick={() => setShowUatModal(false)}
//                   style={{
//                     position: "absolute",
//                     right: "16px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     background: "none",
//                     border: "none",
//                     color: "#00a9da",
//                     fontSize: "28px",
//                     cursor: "pointer",
//                   }}
//                 >
//                   ×
//                 </button>
//               </div>

//               {/* Body */}
//               <div
//                 style={{
//                   padding: isMobile ? "12px" : "24px",
//                   display: "flex",
//                   flexDirection: "column",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   justifyItems: "center",
//                   flexGrow: 1,
//                   overflowY: "auto",
//                   fontSize: "15px",
//                   lineHeight: "1.6",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: isMobile ? "column" : "row",
//                     gap: "20px",
//                   }}
//                 >
//                   <a
//                     href={uatIosLink}
//                     style={{
//                       width: isMobile ? "150px" : "250px",
//                       height: isMobile ? "50px" : "100px",
//                       backgroundColor: "#286090",
//                       alignItems: "center",
//                       justifyItems: "center",
//                       display: "flex",
//                       justifyContent: "center",
//                       color: "#fcfcfc",
//                       borderRadius: "8px",
//                       fontSize: "14px",
//                       flexDirection: "row",
//                       gap: "5px",
//                     }}
//                   >
//                     <IOS style={{ width: "15px", height: "15px" }} />
//                     <span>IOS</span>
//                   </a>
//                   <a
//                     href={uatAndroidLink}
//                     style={{
//                       width: isMobile ? "150px" : "250px",
//                       height: isMobile ? "50px" : "100px",
//                       backgroundColor: "#286090",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       fontSize: "14px",
//                       color: "#fcfcfc",
//                       borderRadius: "8px",
//                       display: "flex",
//                       flexDirection: "row",
//                       gap: "5px",
//                     }}
//                   >
//                     <Android style={{ width: "15px", height: "15px" }} />
//                     <span>Android</span>
//                   </a>
//                 </div>
//               </div>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//       {/* PRODUCTION */}
//       <AnimatePresence>
//         {showProModal && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             style={{
//               position: "fixed",
//               inset: 0, // top-0 right-0 bottom-0 left-0
//               backgroundColor: "rgba(0,0,0,0.5)",
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               zIndex: 9999,
//             }}
//             onClick={() => setShowProModal(false)}
//           >
//             <motion.div
//               initial={{ scale: 0.85, opacity: 0 }}
//               animate={{ scale: 1, opacity: 1 }}
//               exit={{ scale: 0.85, opacity: 0 }}
//               transition={{ type: "spring", damping: 30, stiffness: 400 }}
//               onClick={(e) => e.stopPropagation()}
//               style={{
//                 background: "white",
//                 borderRadius: "8px",
//                 width: modalWidth,
//                 maxHeight: "85vh",
//                 boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
//                 overflow: "hidden",
//                 display: "flex",
//                 flexDirection: "column",
//               }}
//             >
//               {/* Header */}
//               <div
//                 style={{
//                   padding: "18px 20px",
//                   backgroundColor: "#fcfcfc",
//                   color: "#00a9da",
//                   fontWeight: "600",
//                   fontSize: "19px",
//                   textAlign: "start",
//                   position: "relative",
//                   borderBottom: "2px solid",
//                   borderColor: "#e5e5e5",
//                 }}
//               >
//                 PRODUCTION
//                 <button
//                   onClick={() => setShowProModal(false)}
//                   style={{
//                     position: "absolute",
//                     right: "16px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     background: "none",
//                     border: "none",
//                     color: "#00a9da",
//                     fontSize: "28px",
//                     cursor: "pointer",
//                   }}
//                 >
//                   ×
//                 </button>
//               </div>

//               {/* Body */}
//               <div
//                 style={{
//                   padding: isMobile ? "12px" : "24px",
//                   display: "flex",
//                   flexDirection: "column",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   justifyItems: "center",
//                   flexGrow: 1,
//                   overflowY: "auto",
//                   fontSize: "15px",
//                   lineHeight: "1.6",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: isMobile ? "column" : "row",
//                     gap: "20px",
//                   }}
//                 >
//                   <a
//                     href={proIosLink}
//                     style={{
//                       width: isMobile ? "150px" : "250px",
//                       height: isMobile ? "50px" : "100px",
//                       backgroundColor: "#286090",
//                       alignItems: "center",
//                       justifyItems: "center",
//                       display: "flex",
//                       justifyContent: "center",
//                       color: "#fcfcfc",
//                       borderRadius: "8px",
//                       fontSize: "14px",
//                       flexDirection: "row",
//                       gap: "5px",
//                     }}
//                   >
//                     <IOS style={{ width: "15px", height: "15px" }} />
//                     <span>IOS</span>
//                   </a>
//                   <a
//                     href={proAndroidLink}
//                     style={{
//                       width: isMobile ? "150px" : "250px",
//                       height: isMobile ? "50px" : "100px",
//                       backgroundColor: "#286090",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       fontSize: "14px",
//                       color: "#fcfcfc",
//                       borderRadius: "8px",
//                       display: "flex",
//                       flexDirection: "row",
//                       gap: "5px",
//                     }}
//                   >
//                     <Android style={{ width: "15px", height: "15px" }} />
//                     <span>Android</span>
//                   </a>
//                 </div>
//               </div>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// };

// export default DownloadContent;
import React, { useEffect, useState, useRef } from "react";
import Logo_gopaperless from "../../assets/images/logos/paperless/gopaperless-logo-darkblue-2.png";
import Image1 from "../../assets/images/pictures/1.jpg";
import Image2 from "../../assets/images/pictures/2.jpg";
import Image3 from "../../assets/images/pictures/3.jpg";
import Image4 from "../../assets/images/pictures/4.jpg";
import Image5 from "../../assets/images/pictures/5.jpg";
import { ReactComponent as QR } from "../../assets/images/pictures/bing_generated_qrcode.svg";
import { ReactComponent as IOS } from "../../assets/images/pictures/IOS.svg";
import { ReactComponent as Android } from "../../assets/images/pictures/Android.svg";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const DownloadContent = () => {
   const { t } = useTranslation();
  const scrollPositionRef = useRef(0);
  const carouselRef = useRef(null);
  const [showUatModal, setShowUatModal] = useState(false);
  const [showProModal, setShowProModal] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const images = [Image1, Image2, Image3, Image4, Image5];
  const [currentIndex, setCurrentIndex] = useState(0);

  // Hàm chuyển slide
  const nextSlide = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setCurrentIndex((prev) => (prev + 1) % images.length);
    if (e.target) e.target.blur();
  };

  const prevSlide = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
    if (e.target) e.target.blur();
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Ngăn scroll không mong muốn khi tương tác carousel
  useEffect(() => {
    const preventScroll = (e) => {
      if (carouselRef.current && carouselRef.current.contains(e.target)) {
        e.preventDefault();
      }
    };
    document.addEventListener("touchmove", preventScroll, { passive: false });
    return () => document.removeEventListener("touchmove", preventScroll);
  }, []);

  const modalWidth = isMobile ? "90%" : "40%";
  const buttonWidth = isMobile ? "150px" : "250px";
  const buttonHeight = isMobile ? "50px" : "auto";
  const buttonFontSize = isMobile ? "14px" : "14px";

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setShowUatModal(false);
        setShowProModal(false);
      }
    };
    if (showUatModal || showProModal) {
      window.addEventListener("keydown", handleEsc);
      return () => window.removeEventListener("keydown", handleEsc);
    }
  }, [showUatModal, showProModal]);

  // UAT
  const uatIosLink =
    "itms-services://?action=download-manifest&url=https://gopaperless.mobile-id.vn/downloads/uat/ipa/ipad.plist";
  const uatAndroidLink =
    "https://gopaperless.mobile-id.vn/downloads/uat/android/gopaperless.apk";

  // PRODUCTION
  const proIosLink =
    "itms-services://?action=download-manifest&url=https://gopaperless.mobile-id.vn/downloads/production/ipa/ipad.plist";
  const proAndroidLink =
    "https://gopaperless.mobile-id.vn/downloads/production/android/gopaperless.apk";

  return (
    <div
      id="content"
      style={{
        display: "flex",
        flexDirection: "column",
        marginTop: "60px",
        alignItems: "center",
        width: "100%",
        backgroundColor: "white",
        textAlign: "center",
        position: "relative",
        gap: "16px",
      }}
    >
      <Link
        to="/downloads"
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: "block", marginBottom: "16px" }}
      >
        <img
          src={Logo_gopaperless}
          alt="GoPaperless Logo"
          style={{
            maxWidth: isMobile ? "200px" : "300px",
            height: "auto",
            display: "block",
            cursor: "pointer",
          }}
        />
      </Link>

      <QR style={{ width: "200px", height: "200px" }} />

      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: "10px",
        }}
      >
        <button
          onClick={() => setShowProModal(true)}
          className="btn btn-primary rounded-pill px-4 py-2"
          style={{
            fontSize: buttonFontSize,
            fontWeight: 500,
            width: buttonWidth,
            padding: isMobile ? "14px" : "8px 16px",
            minHeight: buttonHeight,
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
          }}
        >
         {t("download-page.production")}
        </button>
        <button
          onClick={() => setShowUatModal(true)}
          className="btn btn-primary rounded-pill px-4 py-2"
          style={{
            fontSize: buttonFontSize,
            fontWeight: 500,
            width: buttonWidth,
            padding: isMobile ? "14px" : "8px 16px",
            minHeight: buttonHeight,
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
          }}
        >
          {t("download-page.demo")}
        </button>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          width: isMobile ? "90%" : "50dvw",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <span style={{ fontSize: "16px", color: "#555", fontWeight: "bold" }}>
            {t("download-page.setting_label")}
        </span>

        <span
          style={{
            fontSize: "14px",
            color: "#555",
            fontWeight: 500,
            textAlign: "center",
          }}
        >
          {t("download-page.setting_note")}
        </span>

        {/* CAROUSEL RESPONSIVE - FULL VIEW, KHÔNG CẮP, SWIPE ĐƯỢC */}

        <div
          ref={carouselRef}
          style={{
            position: "relative",
            width: "100%",
            maxWidth: "90vw", // full trên mobile
            overflow: "hidden",
            borderRadius: "12px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
            margin: "20px auto",
            backgroundColor: "#dddddd",
            touchAction: "pan-y", // cho phép scroll dọc nếu ảnh dài
          }}
        >
          {/* Wrapper cho drag/swipe */}
          <motion.div
            drag="x"
            dragConstraints={{ left: 0, right: 0 }}
            dragElastic={0.2}
            onDragEnd={(e, { offset, velocity }) => {
              if (offset.x < -100 || velocity.x < -500) nextSlide(e);
              else if (offset.x > 100 || velocity.x > 500) prevSlide(e);
            }}
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <AnimatePresence initial={false}>
              <motion.img
                key={currentIndex}
                src={images[currentIndex]}
                alt={`Slide ${currentIndex + 1}`}
                initial={{ x: 300, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: -300, opacity: 0 }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
                style={{
                  width: "100%",
                  height: "auto", // ← tự động chiều cao theo ảnh thật
                  maxHeight: "80vh", // giới hạn không quá cao màn hình, nhưng vẫn full
                  objectFit: "contain", // giữ nguyên không crop
                  display: "block",
                  margin: "0 auto",
                  pointerEvents: "none",
                }}
              />
            </AnimatePresence>
          </motion.div>

          {/* Nút Prev/Next chỉ hiện trên desktop hoặc màn lớn */}
          {!isMobile && (
            <>
              <button
                type="button"
                tabIndex={-1}
                onClick={prevSlide}
                style={{
                  position: "absolute",
                  left: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "rgba(0,0,0,0.5)",
                  color: "white",
                  border: "none",
                  borderRadius: "50%",
                  width: "44px",
                  height: "44px",
                  fontSize: "24px",
                  cursor: "pointer",
                  zIndex: 10,
                }}
              >
                ←
              </button>
              <button
                type="button"
                tabIndex={-1}
                onClick={nextSlide}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "rgba(0,0,0,0.5)",
                  color: "white",
                  border: "none",
                  borderRadius: "50%",
                  width: "44px",
                  height: "44px",
                  fontSize: "24px",
                  cursor: "pointer",
                  zIndex: 10,
                }}
              >
                →
              </button>
            </>
          )}

          {/* Dots responsive */}
          <div
            style={{
              position: "absolute",
              bottom: "10px",
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              gap: isMobile ? "6px" : "8px",
              zIndex: 10,
            }}
          >
            {images.map((_, index) => (
              <button
                key={index}
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setCurrentIndex(index);
                  e.target.blur();
                }}
                style={{
                  width: isMobile ? "8px" : "10px",
                  height: isMobile ? "8px" : "10px",
                  borderRadius: "50%",
                  background:
                    index === currentIndex
                      ? "#00a9da"
                      : "rgba(255,255,255,0.7)",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                }}
              />
            ))}
          </div>
        </div>
      </div>

      {/* UAT Modal */}
      <AnimatePresence>
        {showUatModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              inset: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
            onClick={() => setShowUatModal(false)}
          >
            <motion.div
              initial={{ scale: 0.85, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.85, opacity: 0 }}
              transition={{ type: "spring", damping: 30, stiffness: 400 }}
              onClick={(e) => e.stopPropagation()}
              style={{
                background: "white",
                borderRadius: "8px",
                width: modalWidth,
                maxHeight: "85vh",
                boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  padding: "18px 20px",
                  backgroundColor: "#fcfcfc",
                  color: "#00a9da",
                  fontWeight: "600",
                  fontSize: "19px",
                  textAlign: "start",
                  position: "relative",
                  borderBottom: "2px solid #e5e5e5",
                }}
              >
                  {t("download-page.demo")}
                <button
                  onClick={() => setShowUatModal(false)}
                  style={{
                    position: "absolute",
                    right: "16px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "none",
                    color: "#00a9da",
                    fontSize: "28px",
                    cursor: "pointer",
                  }}
                >
                  ×
                </button>
              </div>

              <div
                style={{
                  padding: isMobile ? "12px" : "24px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  flexGrow: 1,
                  overflowY: "auto",
                  fontSize: "15px",
                  lineHeight: "1.6",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    gap: "20px",
                  }}
                >
                  <a
                    href={uatIosLink}
                    style={{
                      width: isMobile ? "150px" : "250px",
                      height: isMobile ? "50px" : "100px",
                      backgroundColor: "#286090",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fcfcfc",
                      borderRadius: "8px",
                      fontSize: "14px",
                      gap: "5px",
                      textDecoration: "none",
                    }}
                  >
                    <IOS style={{ width: "15px", height: "15px" }} />
                    <span>{t("download-page.ios")}</span>
                  </a>
                  <a
                    download="gopaperless.apk"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={uatAndroidLink}
                    style={{
                      width: isMobile ? "150px" : "250px",
                      height: isMobile ? "50px" : "100px",
                      backgroundColor: "#286090",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fcfcfc",
                      borderRadius: "8px",
                      fontSize: "14px",
                      gap: "5px",
                      textDecoration: "none",
                    }}
                  >
                    <Android style={{ width: "15px", height: "15px" }} />
                    <span>{t("download-page.android")}</span>
                  </a>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* PRODUCTION Modal */}
      <AnimatePresence>
        {showProModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              inset: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
            onClick={() => setShowProModal(false)}
          >
            <motion.div
              initial={{ scale: 0.85, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.85, opacity: 0 }}
              transition={{ type: "spring", damping: 30, stiffness: 400 }}
              onClick={(e) => e.stopPropagation()}
              style={{
                background: "white",
                borderRadius: "8px",
                width: modalWidth,
                maxHeight: "85vh",
                boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  padding: "18px 20px",
                  backgroundColor: "#fcfcfc",
                  color: "#00a9da",
                  fontWeight: "600",
                  fontSize: "19px",
                  textAlign: "start",
                  position: "relative",
                  borderBottom: "2px solid #e5e5e5",
                }}
              >
                {t("download-page.production")}
                <button
                  onClick={() => setShowProModal(false)}
                  style={{
                    position: "absolute",
                    right: "16px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "none",
                    color: "#00a9da",
                    fontSize: "28px",
                    cursor: "pointer",
                  }}
                >
                  ×
                </button>
              </div>

              <div
                style={{
                  padding: isMobile ? "12px" : "24px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  flexGrow: 1,
                  overflowY: "auto",
                  fontSize: "15px",
                  lineHeight: "1.6",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    gap: "20px",
                  }}
                >
                  <a
                    href={proIosLink}
                    style={{
                      width: isMobile ? "150px" : "250px",
                      height: isMobile ? "50px" : "100px",
                      backgroundColor: "#286090",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fcfcfc",
                      borderRadius: "8px",
                      fontSize: "14px",
                      gap: "5px",
                      textDecoration: "none",
                    }}
                  >
                    <IOS style={{ width: "15px", height: "15px" }} />
                    <span>{t("download-page.ios")}</span>
                  </a>
                  <a
                    download="gopaperless.apk"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={proAndroidLink}
                    style={{
                      width: isMobile ? "150px" : "250px",
                      height: isMobile ? "50px" : "100px",
                      backgroundColor: "#286090",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fcfcfc",
                      borderRadius: "8px",
                      fontSize: "14px",
                      gap: "5px",
                      textDecoration: "none",
                    }}
                  >
                    <Android style={{ width: "15px", height: "15px" }} />
                    <span>{t("download-page.android")}</span>
                  </a>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default DownloadContent;
